<template>

  <HeaderYachts :section="section" />

  <nav id="secondary-nav" class="navbar fixed-top d-none d-lg-flex">
    <div class="container-fluid">
      <div class="row w-100 text-center justify-content-around py-2">

        <div class="col-auto" v-if="parent">
          <a href="#" @click.prevent="goToPage(parent.id)">{{ parent.title }}</a>
        </div>

        <div class="col-auto">
          <a href="box-info" @click="scrollToSection">{{ pageItem.title }}</a>
        </div>

        <div v-if="pageItem.interiors || pageItem.exteriors || pageItem.videos" class="col-auto">
          <a href="box-gallery" @click="scrollToSection">Yacht Gallery</a>
        </div>

        <div v-if="pageItem.techData" class="col-auto">
          <a href="box-techdata" @click="scrollToSection">Technical Data</a>
        </div>

        <div v-if="pageItem.layout" class="col-auto">
          <a href="box-ga" @click="scrollToSection">General Arrangement</a>
        </div>

        <div v-if="pageItem.docs" class="col-auto">
          <a href="box-docs" @click="scrollToSection">Documents</a>
        </div>

        <div v-if="hulls.length" class="col-auto">
          <a href="box-hulls" @click="scrollToSection">Hulls</a>
        </div>

      </div>
    </div>
  </nav>

  <div v-if="pageItem.mainImg" class="text-center w-100 mb-2 mb-lg-4">
      <img :src="pageItem.mainImg" class="img-full" />
  </div>

  <div class="container py-4" id="box-info">

    <h1 class="text-center mb-4" v-html="pageTitle"></h1>

    <div id="box-img" v-if="pageItem.mainVideo || pageItem.videoCover" class="text-center my-2 my-lg-4">
       <img v-if="pageItem.videoCover" :src="pageItem.videoCover" class="img-fluid" />
       <div v-if="pageItem.mainVideo" class="play-video">
        <img :src="require('../assets/play-white.svg')" alt="Play video" @click="playVideo()">
      </div>
    </div>

    <div class="" v-html="pageItem.introtext"></div>

  </div>
  
  <YachtGallery v-if="pageItem.interiors || pageItem.exteriors || pageItem.videos" :section="section" :pageItem="pageItem" />

  <YachtTechdata v-if="pageItem.techData" :section="section" :pageItem="pageItem" />

  <YachtLayouts v-if="pageItem.layout" :section="section" :pageItem="pageItem" />

  <YachtDocuments v-if="pageItem.docs" :section="section" :pageItem="pageItem" />

  <YachtHulls v-if="hulls.length" :section="section" :hulls="hulls" />

  <YachtVideo v-if="pageItem.mainVideo" :videoPath="videoPath" @closeVideo="closeVideo" />

</template>

<script>
  import HeaderYachts from './headers/HeaderYachts.vue'
  import YachtTechdata from './YachtTechdata.vue'
  import YachtGallery from './YachtGallery.vue'
  import YachtLayouts from './YachtLayouts.vue'
  import YachtDocuments from './YachtDocuments.vue'
  import YachtHulls from './YachtHulls.vue'
  import YachtVideo from './YachtVideo.vue'

  export default {
    name: 'YachtPage',
    props: ['id'],
    data() {
      return {
        section: this.$store.getters.section,
        pageItems: this.$store.getters['filelist/pageItems'],
        videoPath: null,
        scrollbehavior: this.$store.getters.scrollbehavior,
      }
    },
    computed: {
      sectionPage() {
        if (!this.pageItems) return false
        return this.$store.getters['filelist/pagesFromSection'](this.section)
      },
      pageItem() {
        if (!this.sectionPage) return false
        return this.$store.getters['filelist/pageItemFromId'](this.sectionPage, this.id)
      },
      pageTitle() {
        if (!this.pageItem) return false
        if (this.pageItem.profile) {
          const profile = '<img src="'+ this.pageItem.profile +'" alt="'+ this.pageItem.title +'" class="title-img mx-3">'
          if (!this.pageItem.parentId) {
            return profile
          } else {
            let hullTitle = this.pageItem.title.substring(this.pageItem.title.indexOf('/')) 
            return profile + hullTitle
          }
        }
        return this.pageItem.title
      },
      hulls() {
        if (!this.sectionPage || !this.pageItem) return false
        let hulls = this.sectionPage.gamma.filter((item) => item.parentId == this.pageItem.id)
        return hulls
      },
      parent() {
        if (!this.sectionPage || !this.pageItem || !this.pageItem.parentId) return false
        let parent = this.sectionPage.gamma.find((item) => item.id == this.pageItem.parentId)
        return parent
      },
    },
    methods: {
			closeVideo() {
				this.videoPath = null
        document.body.style.overflowY = 'auto'
        this.$store.dispatch('videos/closeVideo')
			},
			playVideo() {
				this.videoPath = this.pageItem.mainVideo
        document.body.style.overflowY = 'hidden'
        this.$store.dispatch('videos/playVideo')
			},
      scrollToSection(ev) {
        ev.preventDefault()
        let el = ev.target
        let style = window.getComputedStyle(document.body)
        let elTop = style.paddingTop
        elTop = Number(elTop.replace('px', ''))
        let section = document.getElementById(el.getAttribute('href'))
        let sectionTop = section.offsetTop
        window.scrollTo({
          top: (sectionTop - elTop),
          left: 0,
          behavior: this.scrollbehavior,
        })
      },
      goToPage(id) {
        console.log('goToPage from page', id)
        this.$store.dispatch('goToPage', id)
      },
    },
    mounted() {
      document.body.classList.add('yacht-page')
    },
    updated() {
      document.body.classList.add('yacht-page')
    },
    components: {
      HeaderYachts,
      /* HeaderMaiora,
      HeaderAbyachts, */
      YachtTechdata,
      YachtGallery,
      YachtLayouts,
      YachtDocuments,
      YachtHulls,
      YachtVideo
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#box-img {
  position: relative;
}
.img-full {
  width: 100%;
}
</style>
